import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { PaginationResponse } from '../models/common/paginationResponse';
import { Result } from '../models/common/resultResponse';
import { ITemplateEmailNotificationHistoricalApi } from './base/templateEmailNotificationHistoricalApi';
import {
  TemplateEmailNotificationHistoricalSearchGridRequest,
  TemplateEmailNotificationHistoricalDetailRequest
} from '../models/request/templateEmailNotificationRequest';
import {
  TemplateEmailNotificationHistoricalGridResponse,
  TemplateEmailNotificationHistoricalDetailResponse
} from '../models/response/templateEmailNotificationResponse';

const baseRoute: string = 'TemplateEmailNotificationHistorical';

export class TemplateEmailNotificationHistoricalApi extends ITemplateEmailNotificationHistoricalApi {
  searchGridHistorical(
    request: TemplateEmailNotificationHistoricalSearchGridRequest
  ): Promise<AxiosResponse<PaginationResponse<TemplateEmailNotificationHistoricalGridResponse>>> {
    return api.get(`${baseRoute}/search-grid-historical`, { params: request });
  }

  getDetailHistorical(
    request: TemplateEmailNotificationHistoricalDetailRequest
  ): Promise<AxiosResponse<Result<TemplateEmailNotificationHistoricalDetailResponse>>> {
    return api.get(`${baseRoute}/detail-historical`, { params: request });
  }
}
